// Neutral bundled shape for the DME Products, Pricing & Fee Schedule
// ("Exhibit A"). This is a STRUCTURE ONLY — it carries no SKUs and no
// prices.
//
// A per-SKU price list is tenant-confidential commercial data. The bundled
// default ships in every tenant's build, so real prices placed here would
// be one manufacturer's price book handed to its competitors. Pricing must
// arrive exclusively from the per-org `pricing-schedule` template.
// Prices are stored in cents to stay integer-safe.

let cached = null;

export function getDmePricingDefault() {
  if (cached != null) return cached;
  cached = {
    currency: "USD",
    asOfYear: new Date().getFullYear(),
    feeSource: "CMS",
    categories: [],
    paymentTerms: "",
  };
  return cached;
}

// True only when the org has actually configured a price list. Render
// surfaces use this for a "not configured" state; PDF generators use it to
// omit Exhibit A rather than emit an empty or foreign price table.
export function isPricingScheduleConfigured(schedule) {
  if (!schedule || typeof schedule !== "object") return false;
  if (!Array.isArray(schedule.categories)) return false;
  return schedule.categories.some((c) => Array.isArray(c?.items) && c.items.length > 0);
}

export default getDmePricingDefault;
